<template>
  <div class="nav-menu nav-menu-inspiration">
    <div class="nav-menu-inner app-basic-layout-wrapper">
      <div class="main-wrapper">
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-chuangyicankao"></i>
            <h3 class="group-title">创意参考</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="https://hd.weibo.com/originality/list?alk_from=P006_C070"
                  target="_blank"
                  @click="doStat('top_nav_originality_video')"
                >
                  视频
                </a>
              </li>
              <li>
                <a
                  href="https://hd.weibo.com/originality/list?alk_from=P006_C070"
                  target="_blank"
                  @click="doStat('top_nav_originality_post')"
                >
                  博文
                </a>
              </li>
              <li>
                <a
                  href="https://hd.weibo.com/originality/list?alk_from=P006_C070"
                  target="_blank"
                  @click="doStat('top_nav_originality_image')"
                >
                  图片
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-yingxiaoanli"></i>
            <h3 class="group-title">营销案例</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="https://hd.weibo.com/senior/list?alk_from=P006_C070"
                  target="_blank"
                  @click="doStat('top_nav_senior')"
                >
                  微博营销案例
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-yingxiaozixun"></i>
            <h3 class="group-title">营销资讯</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="/article/list?type=4"
                  target="_self"
                  @click="doStat('top_nav_article_sdfx')"
                >
                  深度分析
                </a>
              </li>
              <li>
                <a
                  href="/article/list?type=7"
                  target="_self"
                  @click="doStat('top_nav_article_hydt')"
                >
                  行业动态
                </a>
              </li>
              <li>
                <a
                  href="/article/list?type=2"
                  target="_self"
                  @click="doStat('top_nav_article_qsbg')"
                >
                  趋势报告
                </a>
              </li>
              <li>
                <a
                  href="/article/list?type=4"
                  target="_self"
                  @click="doStat('top_nav_article_hdxm')"
                >
                  活动项目
                </a>
              </li>
              <li>
                <a
                  href="/article/list?type=topic"
                  target="_self"
                  @click="doStat('top_nav_topic')"
                >
                  营销专题
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-xuexipeixun"></i>
            <h3 class="group-title">学习培训</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="https://hd.weibo.com/course/list?alk_from=P006_C070"
                  target="_blank"
                  @click="doStat('top_nav_college')"
                >
                  营销学院
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="extra-wrapper nav-group">
        <div class="group-header">
          <i class="iconfont icon-jingxuan"></i>
          <h3 class="group-title">精选内容</h3>
        </div>
        <div class="group-body">
          <a
            href="https://hd.weibo.com/senior/view/31124?alk_from=P006_C070"
            class="extra-item"
            target="_blank"
            @click="doStat('top_nav_banner_inspiration')"
          >
            <div class="poster">
              <img
                src="https://static.hd.weibo.com/marketing/static/img/fc0cca16-05a0-4b16-a4cf-78db86c15549.jpg"
                alt=""
              />
            </div>
            <h4>
              信良记小龙虾跨界潮流合伙人FOURTRY，如何最大化联名红利、塑造品牌年轻化？
            </h4>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    doStat(module) {
      if (module) {
        this.$stat({
          key: 'nav_click',
          params: { module },
          pathName: this.$route.name
        })
      }
    }
  }
}
</script>
